export default __webpack_public_path__ + "static/media/nextPanel.ed05fe21.webp";